import React, { useState, useEffect } from "react";
import { X, Smartphone } from "lucide-react";

export default function FloatingSideQR() {
  const [isVisible, setIsVisible] = useState(true);

  // Exact Google Play Store direct URL for Medrph Labs
  const DIRECT_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.medrpha_labs.app";
  
  // High quality QR Code directly encoding Google Play Store URL
  const QR_CODE_API_URL = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(
    DIRECT_PLAY_STORE_URL
  )}&color=0f172a&bgcolor=ffffff&margin=0`;

  // Check localStorage if user previously closed it
  useEffect(() => {
    try {
      const closed = localStorage.getItem("medrph_qr_closed");
      if (closed === "true") {
        setIsVisible(false);
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    try {
      localStorage.setItem("medrph_qr_closed", "true");
    } catch (e) {
      console.log(e);
    }
  };

  const handleReopen = () => {
    setIsVisible(true);
    try {
      localStorage.removeItem("medrph_qr_closed");
    } catch (e) {
      console.log(e);
    }
  };

  if (!isVisible) {
    return (
      <button
        onClick={handleReopen}
        className="fixed bottom-6 left-5 z-[9999] bg-white hover:bg-slate-50 text-slate-800 p-2.5 rounded-2xl shadow-xl border border-slate-200 transition-all flex items-center gap-2 group cursor-pointer hover:scale-105"
        title="Show App QR Code"
      >
        <div className="w-8 h-8 rounded-xl bg-red-50 text-red-600 flex items-center justify-center font-bold">
          <Smartphone size={18} />
        </div>
        <div className="text-left pr-1 hidden sm:block">
          <span className="text-[10px] uppercase font-bold text-slate-400 block tracking-wider leading-none">
            Google Play
          </span>
          <span className="text-xs font-black text-slate-800 leading-tight">
            Scan QR
          </span>
        </div>
      </button>
    );
  }

  return (
    <div className="fixed bottom-8 left-5 z-[9999] select-none hidden sm:block animate-bounce-gentle">
      {/* Outer White Card */}
      <div className="relative bg-white rounded-2xl p-3.5 shadow-2xl border border-slate-200/90 w-[215px] text-center">
        
        {/* Close Button Top Right Circle */}
        <button
          onClick={handleClose}
          className="absolute -top-3 -right-3 w-7 h-7 bg-white hover:bg-red-50 text-slate-700 hover:text-red-600 rounded-full flex items-center justify-center shadow-md border border-slate-200 transition-all cursor-pointer z-10"
          title="Close QR"
        >
          <X size={15} />
        </button>

        {/* Header Title */}
        <div className="mb-2 text-center">
          <h4 className="text-xs font-black text-slate-900 tracking-tight">
            Download Android App
          </h4>
          <p className="text-[10px] font-semibold text-slate-500">
            Scan with phone camera
          </p>
        </div>

        {/* Big White QR Code with direct Play Store link */}
        <a 
          href={DIRECT_PLAY_STORE_URL} 
          target="_blank" 
          rel="noopener noreferrer"
          className="block bg-white p-1.5 rounded-xl border border-slate-100 shadow-inner mb-2.5 relative group cursor-pointer"
          title="Open in Google Play Store"
        >
          <img
            src={QR_CODE_API_URL}
            alt="Medrph Labs Play Store App QR"
            className="w-[180px] h-[180px] object-contain rounded-lg mx-auto"
            loading="lazy"
          />
          <div className="absolute inset-0 m-auto w-9 h-9 bg-white rounded-lg shadow-sm border border-slate-200 flex items-center justify-center pointer-events-none group-hover:scale-110 transition-transform">
            <Smartphone size={17} className="text-red-600" />
          </div>
        </a>

        {/* Google Play Store Badge */}
        <a
          href={DIRECT_PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-1.5 py-1.5 px-3 bg-slate-900 hover:bg-black text-white rounded-xl text-[10px] font-bold transition-all shadow-xs"
        >
          <svg className="w-3.5 h-3.5 fill-current text-white" viewBox="0 0 24 24">
            <path d="M3.609 1.814L13.792 12 3.61 22.186a1.91 1.91 0 0 1-.22-.924V2.738c0-.34.08-.655.22-.924zm1.474-1.222l11.455 6.613-3.084 3.084L5.083.592zm11.455 16.203L5.083 23.408l8.36-8.36 3.095 3.095v.001l-.001.001-.001.001zM17.43 12.71l2.455-1.417c.806-.466.806-1.22 0-1.686L17.43 8.19 14.88 10.74l2.55 2.55v-.001l.001.001.001.001-.002.001z"/>
          </svg>
          <span>GET IT ON Google Play</span>
        </a>

      </div>

      {/* Gentle bounce CSS */}
      <style>{`
        @keyframes gentleBounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        .animate-bounce-gentle {
          animation: gentleBounce 2.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
